import ExtendableError from 'utils/ExtendableError';

export class FatalError extends ExtendableError {}
